import React from 'react'
import { get } from 'lodash-es'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../../sharedLegacy/components'
import { ScheduleTimerComponent } from '..'

import './WebinarSecondaryBarComponent.scss'

interface WebinarSecondaryBarProps {
  isProducer: boolean
  schedule: Record<string, any>
  onLiveCountdownZero: Function
  isDraft: boolean
  toggleWebinarOverOverlay: Function
  isWebinarOverlayVisible: boolean
  webinarEnded: boolean
  hideCollapseButton: boolean
}

const WebinarSecondaryBarComponent = ({
  isProducer,
  schedule,
  onLiveCountdownZero,
  isDraft,
  toggleWebinarOverOverlay,
  isWebinarOverlayVisible,
  webinarEnded = false,
  hideCollapseButton,
}: WebinarSecondaryBarProps) => {
  if (webinarEnded) {
    return (
      <div className="webinar-secondary-bar-component">
        <div className="warning-wrapper over">
          <FormattedMessage defaultMessage="Webinar has ended" />
        </div>
        {isProducer && !hideCollapseButton && (
          <Button
            color="themed"
            style={{
              color: 'white',
              backgroundColor: 'rgb(255 255 255 / 10%)',
            }}
            onClick={toggleWebinarOverOverlay}
            size="small"
          >
            {isWebinarOverlayVisible
              ? intl.formatMessage({
                  defaultMessage: 'Collapse Webinar Results',
                })
              : intl.formatMessage({ defaultMessage: 'Show Summary' })}
          </Button>
        )}
      </div>
    )
  }

  let strongMessage
  let message

  if (isDraft) {
    strongMessage = intl.formatMessage({ defaultMessage: 'Draft Mode' })
    message = intl.formatMessage({
      defaultMessage: 'This is a safe environment to test things.',
    })
  } else {
    if (isProducer) {
      strongMessage = intl.formatMessage({
        defaultMessage: 'You are not live yet.',
      })
      message = (
        <ScheduleTimerComponent
          startTimeEpoch={get(schedule, 'start_time_epoch')}
          onLiveCountedownZero={onLiveCountdownZero}
        />
      )
    } else {
      strongMessage = intl.formatMessage({
        defaultMessage: 'Webinar is not live yet.',
      })
    }
  }

  return (
    <div className="webinar-secondary-bar-component">
      <div className="warning-wrapper rehearsal">
        {strongMessage && <strong>{strongMessage}</strong>}
        {message && message}
      </div>
    </div>
  )
}

export default WebinarSecondaryBarComponent
